import React, { Component } from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import PropTypes from 'prop-types';
import { LabeledSelect } from '../LabeledSelect';
import { FieldHelpIcon } from '../../icon/FieldHelpIcon';
import { helpModalControl } from '../../modals/HelpModalControl';

class MinMaxSelectSearchCardUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.handleHelpClick = this.handleHelpClick.bind(this);
    this.renderSelect = this.renderSelect.bind(this);
  }

  handleHelpClick(e) {
    e.preventDefault();
    const { toggleHelpModal, helpModalId } = this.props;
    if (helpModalId) {
      toggleHelpModal(helpModalId);
    }
  }

  renderSelect(isMin) {
    const {
      colStyle,
      model,
      minField,
      maxField,
      sorted,
      descriptors,
      prependId,
      minLabel,
      maxLabel,
    } = this.props;
    return (
      <LabeledSelect
        formGroupClassName={[colStyle]}
        parentModel={model}
        fieldId={isMin ? minField : maxField}
        label={isMin ? minLabel : maxLabel}
        sorted={sorted}
        prependId={prependId}
        childOptions={descriptors}
      />
    );
  }

  render() {
    const {
      children,
      className,
      helpModalId,
      descending,
    } = this.props;
    return (
      <Card className={`haz-inner-card ${className}`}>
        <CardBody>
          <CardTitle>
            <div className="haz-help-icon-inline">
              <span>{children}</span>
              {helpModalId && <span><FieldHelpIcon tooltipLabel={helpModalId} handleClick={this.handleHelpClick} /></span>}
            </div>
          </CardTitle>
          <div className="form-row">
            {this.renderSelect(!descending)}
            {this.renderSelect(descending)}
          </div>
        </CardBody>
      </Card>
    );
  }
}


MinMaxSelectSearchCardUnwrapped.propTypes = {
  children: PropTypes.node.isRequired,
  model: PropTypes.string.isRequired,
  minField: PropTypes.string.isRequired,
  maxField: PropTypes.string.isRequired,
  className: PropTypes.string,
  toggleHelpModal: PropTypes.func.isRequired,
  helpModalId: PropTypes.string,
  colStyle: PropTypes.string,
  sorted: PropTypes.bool,
  descriptors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })).isRequired,
  prependId: PropTypes.bool,
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
  descending: PropTypes.bool,
};

MinMaxSelectSearchCardUnwrapped.defaultProps = {
  className: undefined,
  helpModalId: '',
  colStyle: 'col-lg-6',
  sorted: false,
  prependId: false,
  minLabel: 'Min',
  maxLabel: 'Max',
  descending: false,
};

export const MinMaxSelectSearchCard = helpModalControl(MinMaxSelectSearchCardUnwrapped);
